import type { KeycloakInstance } from "keycloak-js";

// Interactive sign-in starts at Home; provider initialization and token renewal keep their route.
export function signIn(client: Pick<KeycloakInstance, "login">) {
  return client.login({ redirectUri: new URL("/", window.location.origin).href });
}

export function signOut(client: Pick<KeycloakInstance, "logout">) {
  return client.logout({ redirectUri: new URL("/", window.location.origin).href });
}
